import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import ArrowLeftIcon from "@heroicons/react/24/outline/ArrowLeftIcon";
import ArrowRightIcon from "@heroicons/react/24/outline/ArrowRightIcon";
import { useTranslation } from "@/hooks/translationContext";

export default function ScrollButtons({
  refOfTheElement,
  lengthOfDatas,
}: {
  refOfTheElement: any;
  lengthOfDatas: number;
}) {
  const { t } = useTranslation();
  const [clientWidth, setClientWidth] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [scrollWidth, setScrollWidth] = useState(0);

  useEffect(() => {
    const currentElement = refOfTheElement.current;

    const listenerFunction = () => {
      if (currentElement) {
        setClientWidth(currentElement.clientWidth);
        setScrollWidth(currentElement.scrollWidth);
        setScrollLeft(currentElement.scrollLeft);
      }
    };

    if (currentElement) {
      currentElement.addEventListener("scroll", listenerFunction, true);
    }

    return () => {
      if (currentElement) {
        currentElement.removeEventListener("scroll", listenerFunction, true);
      }
    };
  }, [refOfTheElement]);

  return (
    <>
      <button
        aria-label={t("venue-detail-scroll-back-label")}
        onClick={() => {
          if (refOfTheElement.current) {
            refOfTheElement.current.scrollBy({
              left: -200,
              behavior: 'smooth'
            });
          }
        }}
        className={cn(
          `duration-150 absolute items-center left-[8px] text-xl w-8 h-8 top-[calc(50%+12px)] translate-y-[-50%] rounded-full flex justify-center bg-white text-primary`,
          scrollLeft === 0 && "!opacity-0",
        )}
      >
        <ArrowLeftIcon className="size-4" />
      </button>

      <button
        aria-label={t("venue-detail-scroll-next-label")}
        onClick={() => {
          if (refOfTheElement.current) {
            refOfTheElement.current.scrollBy({
              left: 200,
              behavior: 'smooth'
            });
          }
        }}
        className={cn(
          `opacity-100 duration-150 absolute items-center right-[8px] text-xl w-8 h-8 top-[calc(50%+12px)] translate-y-[-50%] rounded-full flex justify-center bg-white text-primary`,
          scrollLeft !== 0 &&
          Math.abs(scrollLeft + clientWidth - scrollWidth) <= 5 &&
          "!opacity-0",
          lengthOfDatas < 3 && "!opacity-0",
        )}
      >
        <ArrowRightIcon className="size-4" />
      </button>
    </>
  );
}
